import type { MaintenanceActivityDto } from '../../services/api';
import { i18nService, t, translateMaintenanceActivityCategory } from '../../services/i18n';
import { escapeHtml, formatDate, PROPERTY_ICONS } from './property-shared';

function isPlanned(activityDate: string): boolean {
  const date = new Date(activityDate);
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  date.setHours(0, 0, 0, 0);
  return date.getTime() > today.getTime();
}

function isImageAttachment(contentType?: string): boolean {
  return Boolean(contentType?.startsWith('image/'));
}

export class RcPropertyMaintenanceTab extends HTMLElement {
  activities: MaintenanceActivityDto[] = [];

  render(): void {
    this.innerHTML = `
      <div class="tab-toolbar">
        <button class="btn btn-primary btn-sm" data-action="add-maintenance-activity">${PROPERTY_ICONS.plus} ${t('maintenanceActivities.add')}</button>
      </div>
      ${this.activities.length === 0
        ? `<div class="empty-state"><p>${t('maintenanceActivities.empty')}</p></div>`
        : `<div class="timeline-list">
            ${this.activities.map((activity) => `
              <article class="timeline-entry maintenance-entry">
                <div class="timeline-dot"></div>
                <div class="timeline-content">
                  <div class="maintenance-entry-header">
                    <div>
                      <div class="maintenance-entry-meta">
                        <span class="badge badge-info">${escapeHtml(translateMaintenanceActivityCategory(activity.category))}</span>
                        <span class="badge ${isPlanned(activity.activityDate) ? 'badge-warning' : 'badge-success'}">${t(isPlanned(activity.activityDate) ? 'maintenanceActivities.planned' : 'maintenanceActivities.completed')}</span>
                      </div>
                      <h3 class="maintenance-entry-title">${escapeHtml(activity.description)}</h3>
                    </div>
                    <div class="maintenance-entry-date">${formatDate(activity.activityDate)}</div>
                  </div>
                  <div class="maintenance-entry-body">
                    ${activity.amount != null ? `<div class="maintenance-entry-amount">${escapeHtml(i18nService.formatCurrency(activity.amount))}</div>` : ''}
                    ${activity.attachmentFileName ? `
                      <div class="maintenance-entry-attachment">
                        ${isImageAttachment(activity.attachmentContentType) && activity.attachmentDownloadUrl
                          ? `<a href="${escapeHtml(activity.attachmentDownloadUrl)}" target="_blank" rel="noopener noreferrer">
                              <img class="maintenance-entry-preview" src="${escapeHtml(activity.attachmentDownloadUrl)}" alt="${escapeHtml(activity.attachmentFileName)}">
                            </a>`
                          : ''}
                        <div class="maintenance-entry-attachment-meta">
                          <div class="text-sm">${escapeHtml(activity.attachmentFileName)}</div>
                          <div class="card-actions">
                            <button class="btn btn-outline btn-sm" data-action="download-maintenance-attachment" data-id="${activity.id}">${t('common.download')}</button>
                          </div>
                        </div>
                      </div>
                    ` : ''}
                  </div>
                  <div class="card-actions">
                    <button class="btn btn-danger btn-sm" data-action="delete-maintenance-activity" data-id="${activity.id}">${t('common.delete')}</button>
                  </div>
                </div>
              </article>
            `).join('')}
          </div>`}
    `;
  }
}

if (!customElements.get('rc-property-maintenance-tab')) {
  customElements.define('rc-property-maintenance-tab', RcPropertyMaintenanceTab);
}
